export const veeCustomMessage = {
  en: {
    custom: {
      field: {
        required: "field is required",
        digits: (field, params) => `length must be ${params[0]}`
      },
      "Phone Number": {
        phone_country: "Phone number is invalid"
      }
    }
  }
};
